import { useState, useEffect } from "react";
import { useDate } from "@/utility/useDate";
import { Tooltip } from "@mui/material";

interface IDurationTimerProps {
  startTime?: string | null;
  endTime?: string | null;
};

function formatDuration(ms: number): string {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function DurationTimer({ startTime, endTime }: IDurationTimerProps) {
  const [elapsed, setElapsed] = useState(0);
  const { toFormattedDateTimeString } = useDate()

  useEffect(() => {
    if (!startTime) {
      return;
    }

    const start = new Date(startTime).getTime();
    const end = endTime ? new Date(endTime).getTime() : null;

    setElapsed((end ?? Date.now()) - start);

    if (!end) {
      const interval = setInterval(() => {
        setElapsed(Date.now() - start);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [startTime, endTime]);

  if (!startTime) {
    return null;
  }

  return (
    <Tooltip
      title={`${toFormattedDateTimeString(startTime)} ${endTime ? `- ${toFormattedDateTimeString(endTime)}` : ''}`}
    >
      <span>({formatDuration(elapsed)})</span>
    </Tooltip>
  );
}

export default DurationTimer;
